module.exports = __webpack_public_path__ + "static/img/vzoom.5fd6cbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/handoff/clients/vzoom.png
// module id = RGZs
// module chunks = 1